/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{isMemoryManagedView as r}from"../../support/MemoryManagedView.js";function o(o){return r(o)}export{o as isMemoryManagedLayerView};
